import { getWebsiteUrl } from './config';

/**
 * The consent card's "How we handle data" link is a path on complyedge.io. On
 * this origin it must be absolute, so the shared script reads the website
 * origin from <html data-ce-site-origin>. Imported before the script runs.
 */
document.documentElement.setAttribute('data-ce-site-origin', getWebsiteUrl());
